import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * Smallest possible proof that this environment's Zocdoc credentials work: request a
 * client-credentials token and report whether Zocdoc issued one. Never returns the token.
 */
export const zocdocTestConnection = oc
  .route({ method: 'POST', path: '/v2/zocdoc/test-connection' })
  .output(
    z.object({
      ok: z.boolean(),
      tokenType: z.string().optional(),
      expiresInSeconds: z.number().optional(),
      scope: z.string().optional(),
      /** Env vars that are unset, when that is why the check could not run. */
      missingEnv: z.array(z.string()).optional(),
      /** Zocdoc's machine-readable code plus HTTP status — never a response body. */
      status: z.number().optional(),
      error: z.string().optional(),
    }),
  )
